import * as React from 'react';
interface Props {
  dataTestId: string;
}
const LogoutIcon = ({ dataTestId }: Props) => (
  <svg
    width="201"
    height="160"
    viewBox="0 0 201 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={dataTestId}
  >
    <rect x="0.5" width="200" height="160" fill="#FAFAFC" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.8996 107.2H123.7C124.112 107.2 124.513 107.156 124.9 107.071C125.286 107.156 125.688 107.2 126.1 107.2H167.7C170.792 107.2 173.3 104.693 173.3 101.6C173.3 98.5074 170.792 96.0002 167.7 96.0002H162.9C159.807 96.0002 157.3 93.493 157.3 90.4002C157.3 87.3074 159.807 84.8002 162.9 84.8002H178.1C181.192 84.8002 183.7 82.293 183.7 79.2002C183.7 76.1074 181.192 73.6002 178.1 73.6002H160.5C163.592 73.6002 166.1 71.093 166.1 68.0002C166.1 64.9074 163.592 62.4002 160.5 62.4002H109.3C112.392 62.4002 114.9 59.893 114.9 56.8002C114.9 53.7074 112.392 51.2002 109.3 51.2002H63.6996C60.6068 51.2002 58.0996 53.7074 58.0996 56.8002C58.0996 59.893 60.6068 62.4002 63.6996 62.4002H31.6996C28.6068 62.4002 26.0996 64.9074 26.0996 68.0002C26.0996 71.093 28.6068 73.6002 31.6996 73.6002H51.6996C54.7924 73.6002 57.2996 76.1074 57.2996 79.2002C57.2996 82.293 54.7924 84.8002 51.6996 84.8002H19.6996C16.6068 84.8002 14.0996 87.3074 14.0996 90.4002C14.0996 93.493 16.6068 96.0002 19.6996 96.0002H50.8996C47.8068 96.0002 45.2996 98.5074 45.2996 101.6C45.2996 104.693 47.8068 107.2 50.8996 107.2ZM181.3 107.2C184.392 107.2 186.9 104.693 186.9 101.6C186.9 98.5074 184.392 96.0002 181.3 96.0002C178.207 96.0002 175.7 98.5074 175.7 101.6C175.7 104.693 178.207 107.2 181.3 107.2Z"
      fill="#F3F7FF"
    />
    <path
      d="M144.5 27V31.8"
      stroke="#FF923F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M144.5 38.2002V43.0002"
      stroke="#FF923F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M136.5 34.9999H141.3"
      stroke="#FF923F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M147.699 34.9999H152.499"
      stroke="#FF923F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.9 116V119.2"
      stroke="#FF923F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.9 125.6V128.8"
      stroke="#FF923F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.5 122.4H50.7"
      stroke="#FF923F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.0996 122.4H60.2996"
      stroke="#FF923F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M101.5 116H78.8333C75.8275 116 72.9449 115.145 70.8195 113.624C68.694 112.103 67.5 110.04 67.5 107.889V51.1111C67.5 48.9599 68.694 46.8968 70.8195 45.3757C72.9449 43.8546 75.8275 43 78.8333 43H101.5"
      fill="#FAFAFC"
    />
    <path
      d="M96.5 113H78.5C76.1131 113 73.8239 112.227 72.136 110.852C70.4482 109.477 69.5 107.612 69.5 105.667V54.3333C69.5 52.3884 70.4482 50.5231 72.136 49.1479C73.8239 47.7726 76.1131 47 78.5 47H96.5"
      fill="#EBF1FF"
    />
    <path
      d="M91.8333 116H75.6111C73.4599 116 71.3968 115.145 69.8757 113.624C68.3546 112.103 67.5 110.04 67.5 107.889V51.1111C67.5 48.9599 68.3546 46.8968 69.8757 45.3757C71.3968 43.8546 73.4599 43 75.6111 43H91.8333"
      stroke="#5C92FF"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M71.8008 89.9053V70.7656"
      stroke="#5C92FF"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M71.8418 100.75L71.8418 95.75"
      stroke="#5C92FF"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M119.483 82.4386C117.652 82.4386 115.936 82.4386 114.218 82.4386C108.356 82.4386 102.495 82.4516 96.6325 82.4354C93.4356 82.4257 91.4981 79.2739 93.0391 76.5822C93.7921 75.267 95.0082 74.59 96.5576 74.5852C102.668 74.5706 108.781 74.5803 114.891 74.5803C116.277 74.5803 117.663 74.5819 119.049 74.5803C119.156 74.5803 119.261 74.5674 119.473 74.5528C118.924 74.0248 118.44 73.5567 117.952 73.0903C116.449 71.6569 114.936 70.2317 113.445 68.787C112.184 67.5642 111.843 65.8312 112.531 64.3234C113.675 61.8146 117.102 61.2024 119.148 63.154C122.213 66.0774 125.267 69.0105 128.325 71.9388C129.598 73.1567 130.878 74.3698 132.152 75.5877C133.93 77.2867 133.958 79.708 132.185 81.4102C127.889 85.5353 123.584 89.6507 119.269 93.7564C117.214 95.7113 114.125 95.3631 112.724 93.047C111.809 91.5359 112.056 89.594 113.337 88.3583C115.264 86.5006 117.204 84.6526 119.136 82.7982C119.231 82.7075 119.318 82.6087 119.484 82.4354L119.483 82.4386ZM125.595 80.0157C125.44 80.1777 125.36 80.2684 125.273 80.351C123.809 81.7454 122.341 83.1351 120.879 84.5328C118.971 86.3548 117.065 88.1769 115.166 90.0054C114.515 90.6322 114.5 91.5116 115.111 92.1352C115.769 92.8089 116.747 92.7668 117.545 92.0186C118.371 91.2412 119.191 90.4573 120.011 89.6734C122.678 87.1241 125.343 84.5733 128.009 82.0208C128.828 81.2369 129.656 80.4611 130.461 79.661C131.202 78.9241 131.192 78.1208 130.468 77.3741C130.383 77.2867 130.293 77.2025 130.203 77.1166C129.007 75.9764 127.807 74.8378 126.613 73.6944C123.561 70.7759 120.512 67.8541 117.46 64.9356C116.77 64.2764 115.757 64.2537 115.114 64.8757C114.488 65.4814 114.536 66.424 115.239 67.1107C115.631 67.4929 116.034 67.8606 116.429 68.238C119.036 70.7305 121.642 73.2247 124.247 75.7189C124.664 76.1173 125.075 76.5206 125.565 76.9952C125.307 76.9952 125.172 76.9952 125.035 76.9952C115.609 76.9952 106.183 76.9952 96.7575 76.9984C95.6913 76.9984 94.9999 77.6057 95.0066 78.5273C95.0116 79.4294 95.7046 80.0189 96.7491 80.0189C106.19 80.0189 115.629 80.0189 125.07 80.0189H125.598L125.595 80.0157Z"
      fill="#5C92FF"
    />
    <path
      d="M125.596 80.0142H125.067C115.627 80.0142 106.187 80.0142 96.7465 80.0142C95.702 80.0142 95.0106 79.4246 95.004 78.5225C94.9973 77.6009 95.6887 76.9936 96.7549 76.9936C106.181 76.992 115.607 76.992 125.032 76.9904C125.167 76.9904 125.302 76.9904 125.562 76.9904C125.072 76.5158 124.661 76.1125 124.244 75.7141C121.639 73.2199 119.033 70.7257 116.426 68.2332C116.031 67.8558 115.627 67.4882 115.237 67.1059C114.535 66.4208 114.485 65.4782 115.112 64.8709C115.755 64.2489 116.769 64.2716 117.457 64.9308C120.509 67.8493 123.558 70.7711 126.61 73.6896C127.805 74.8314 129.004 75.97 130.2 77.1118C130.288 77.196 130.378 77.2803 130.465 77.3693C131.19 78.116 131.2 78.9193 130.458 79.6562C129.654 80.4563 128.826 81.2321 128.006 82.016C125.341 84.5669 122.675 87.1177 120.008 89.6686C119.188 90.4525 118.37 91.238 117.542 92.0138C116.746 92.762 115.768 92.8042 115.108 92.1304C114.499 91.5069 114.512 90.6258 115.163 90.0006C117.064 88.1721 118.97 86.35 120.876 84.528C122.339 83.1319 123.806 81.7407 125.271 80.3462C125.357 80.2636 125.437 80.1729 125.592 80.0109L125.596 80.0142Z"
      fill="#FAFAFC"
    />
  </svg>
);
export default LogoutIcon;
